'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Get the filename without the extension
 * @example testFilename.jpg => testFilename
 * @param filename string
 * @returns string
 */ const removeFileExtension = (filename)=>{
    return filename.replace(/\.[^.]*$/, '') || filename;
};

exports.removeFileExtension = removeFileExtension;
//# sourceMappingURL=remove-file-extension.js.map
